import { Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

type TransactionStepHeaderProps = {
  title: string;
  subtitle?: string;
  subtitleSx?: SxProps<Theme>;
};

export const TransactionStepHeader = ({
  title,
  subtitle,
  subtitleSx,
}: TransactionStepHeaderProps) => (
  <>
    <Typography variant="h6" component="h3" gutterBottom>
      {title}
    </Typography>
    {subtitle != null && (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={subtitleSx ?? { mb: 1 }}
      >
        {subtitle}
      </Typography>
    )}
  </>
);
